// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  text: '',
  recentLoading: false,
  searchLoading: false,
  bookshopTotal: {
    Value: 0,
    Vouchers: 0,
    Customers: 0,
  },
  vouchers: [],
  recentVouchers: [],
};

const vouchersReducer = createReducer(initialState, {
  [types.VOUCHERS_START_RECENT_LOADER](state) {
    return {
      ...state,
      recentLoading: true,
    };
  },
  [types.VOUCHERS_STOP_RECENT_LOADER](state) {
    return {
      ...state,
      recentLoading: false,
    };
  },
  [types.VOUCHERS_START_SEARCH_LOADER](state) {
    return {
      ...state,
      searchLoading: true,
    };
  },
  [types.VOUCHERS_STOP_SEARCH_LOADER](state) {
    return {
      ...state,
      searchLoading: false,
    };
  },
  [types.GET_BOOKSHOP_TOTAL_SUCCESS](state, action) {
    return {
      ...state,
      bookshopTotal: action.payload,
    };
  },
  [types.GET_RECENT_VOUCHERS_SUCCESS](state, action) {
    return {
      ...state,
      recentVouchers: action.payload,
    };
  },
  [types.CHANGE_SEARCH_FIELD](state, action) {
    return {
      ...state,
      [action.field]: action.value,
    };
  },
  [types.SEARCH_VOUCHERS_SUCCESS](state, action) {
    return {
      ...state,
      vouchers: action.payload,
    };
  },
  [types.VOUCHERS_CLEAR_SEARCH_RESULT](state) {
    return {
      ...state,
      vouchers: initialState.vouchers,
      text: initialState.text,
    };
  }
});

export default vouchersReducer;
